import { createSelector } from 'reselect';

const getNotifications = state => state.app.notifications;
const getCountries = state => state.app.Countries;
const getTimezones = state => state.app.Timezones;
const getLanguages = state => state.app.Languages;
const getTrunksQtty = state => state.app.Trunks;
const getIsNano = state => state.app.isNano;
const getHasSetup = state => state.app.hasSetup;

export const notificationsSelector = createSelector(
    getNotifications,
    notifications => notifications
);

export const countriesSelector = createSelector(
    getCountries,
    countries => countries
);

export const timezonesSelector = createSelector(
    getTimezones,
    timezones => timezones
);

export const languagesSelector = createSelector(
    getLanguages,
    languages => languages
);

export const trunksQttySelector = createSelector(
    getTrunksQtty,
    trunkQtty => trunkQtty
);

export const isNanoSelector = createSelector(
    getIsNano,
    isNano => isNano
);

export const hasSetupSelector = createSelector(
    getHasSetup,
    hasSetup => hasSetup
);
